module.exports = __webpack_public_path__ + "static/media/schedule.a11eee70.svg";